export enum EndPoints {
    AIRSTAFF = "/app/api/catalogs/air_staff",
    AIRBASE = "/app/api/catalogs/airbases",
    AIRTRANSPORT = "/app/api/catalogs/transport/avia",
    CONTRACTORS = "/app/api/catalogs/contractors",
    CONTRACTS = "/app/api/catalogs/contracts",
    CONTRACT_WORKS = "/app/api/catalogs/contract_works",
    CONTRACT_AIRCRAFTS = "/app/api/catalogs/contract_aircrafts",
    WORKTYPES = "/app/api/catalogs/works",
    WORKCOST = "/app/api/flights/work_cost",
    WORKLIGHTS = "/app/api/flights/work",
    WORKSCOMPLETED = "/app/api/flights/works-completed",
    PILOTS = "/app/api/flights/pilots_observers",
    TRANSPORT = "/app/api/kernel/transport/avia",
    REVIEW = "/app/api/flights/review",
    LANDCATEGORY = "/app/api/catalogs/land-categories",
    AIRROUTES = "/app/api/catalogs/patroul-air-routes/pagination",
}
